import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Domain } from 'src/app/model/enum/observations/domain.enum';
import { SubdomainLookup } from 'src/app/model/interfaces/SubdomainLookup.interface';

@Component({
    selector: 'app-subdomain-summary',
    templateUrl: './subdomain-summary.component.html',
    styleUrls: ['./subdomain-summary.component.scss']
})
export class SubdomainSummaryComponent {
    @Input() domain?: Domain;
    @Input() subdomain?: SubdomainLookup;
    @Input() isActive?: boolean;
    @Input() showFocusAreas?: boolean = false;
    @Input() isFocusArea?: boolean = false;
    @Input() readonly?: boolean = false;

    @Output() onClick = new EventEmitter<{ domain?: Domain, subdomain?: SubdomainLookup }>();
    @Output() onClickFocus = new EventEmitter<{ domain?: Domain, subdomain?: SubdomainLookup, isFocusArea?:boolean }>();

    onClickSubdomain() {
        this.onClick.emit({ domain: this.domain, subdomain: this.subdomain })
    }

    onClickFocusArea(focused:boolean) {
        this.isFocusArea = focused;
        this.onClickFocus.emit({ domain: this.domain, subdomain: this.subdomain, isFocusArea: this.isFocusArea })
    }
}
